import client from '@/apis/http-client'
import Vue from 'vue'
let pathUrl = `/por/api`
// const pathOrgUrl = `por/api/organization?page_size=1000`
const pathOrgUrl = `por/api/organization/permission`
import qs from 'qs'

// Initial state.
const defaultState = () => {
  return {
    // Filters
    orgList: {
      all: [],
      selected: []
    },
    departmentList: [],
    filterDepartment: null,
    filterStatus: null,
    filterForPackage: null,
    filterChannel: null,
    textSearch: '',
    // List of packages
    isLoading: false,
    appointmentList: [],
    currentPage: 1,
    totalAppointments: 0,
    pageSize: 25,
    total: 0,
    sortBy: 'update_date',
    sortDesc: 'DESC',
    appointmentObject: {
      "id": 0,
      "uid": "",
      "apt_code": "",
      "apt_type": "",
      "apt_date": "",
      "apt_start_time": "",
      "apt_end_time": "",
      "appointmentDateTime": "",
      "apt_description": "",
      "apt_files": [],
      "is_status": "",
      "remark": "",
      "display_type": "",
      "org_codename": "",
      "org": {
          "codename": "",
          "name": "",
          "icon": ""
      },
      "doctor": {
          "doctor_id": 0,
          "license_no": "",
          "name": "",
          "prefix_name": "",
          "specialist": null
      },
      "department": {
          "department_id": 0,
          "department_name": ""
      },
      "customer": {
          "prefix": "",
          "fullname": "",
          "phone": "",
          "email": "",
          "gender": "",
          "birthdate": "",
          "nationality": ""
      },
      "user_package": null,
      "created_at": "",
      "updated_at": "",
      "audit_logs": []
    }
  }
}

// State
let state = defaultState()
// Actions
const actions = {
  async setListOrgInfo({commit}) {
    let data = await client.secureHttpClient.get(
      `${pathOrgUrl}?permission=View&category=Appointments`
    )
    commit('SET_ORG_FILTER', data.data)
  },
  setIsLoading({commit}, show) {
    commit('SET_IS_LOADING', show)
  },
  resetList({commit}) {
    commit('RESET_LIST_STATE')
  },
  resetDepartmentList({commit}) {
    commit('SET_DEPARTMENT_LIST', defaultState().departmentList)
  },
  resetState({commit}) {
    commit('RESET_STATE')
  },
  setPage({commit}, page) {
    commit('SET_PAGE', page)
  },
  setPageSize({commit}, size) {
    commit('SET_PAGE_SIZE', size)
  },
  setFilterDepartment({commit}, departments) {
    commit('SET_FILTER_DEPARTMENT', departments)
  },
  setFilterChannel({commit}, channel) {
    commit('SET_FILTER_CHANNEL', channel)
  },
  setFilterStatus({commit}, status) {
    commit('SET_FILTER_STATUS', status)
  },
  setFilterForPackage({commit}, for_package) {
    commit('SET_FILTER_FOR_PACKAGE', for_package)
  },
  setTextSearch({commit}, text) {
    if (text == state.textSearch) return
    commit('SET_TEXT_SEARCH', text)
  },
  setFieldSort({commit}, field) {
    if (field) {
      commit('SET_FIELD_SORT', field)
    } else {
      commit('SET_FIELD_SORT', defaultState().sortBy)
    }
  },
  setSort({commit}, sort) {
    commit('SET_SORT', sort === undefined ? 'DESC' : sort ? 'DESC' : 'ASC')
  },
  // API calls
  async fetch({commit}) {
    const {
      currentPage,
      pageSize,
      textSearch,
      filterDepartment,
      filterForPackage,
      filterChannel,
      filterStatus,
      sortBy,
      sortDesc,
      orgList
    } = state
    commit('SET_IS_LOADING', true)
    try {
      const params = {
        page: currentPage,
        limit: pageSize,
        q: `${encodeURIComponent(textSearch)}`,
        orderBy: sortBy,
        sort: sortDesc,
        ...(filterDepartment !== null && {department_id: filterDepartment}),
        ...(filterChannel !== null && {display_type: filterChannel}),
        ...(filterStatus !== null && {is_status: filterStatus}),
        ...(filterForPackage !== null && {for_pagekage: filterForPackage}),
        ...(orgList.selected.length > 0 && {
          orgs: orgList.selected.map(o => o.codename)
        })
      }
      let data = await client.secureHttpClient.get(`${pathUrl}/appointments`, {
        params,
        paramsSerializer: params => qs.stringify(params, {encode: false})
      })
      commit('SET_TOTAL_APPOINTMENTS', data.data.total)
      commit('SET_APPOINTMENTS_LIST', data.data.results)
      commit('SET_IS_LOADING', false)
    } catch (e) {
      Vue.$log.error(e)
      commit('SET_IS_LOADING', false)
    }
  },
  async fetchDepartment({commit}, orgs) {
    try {
      const params = {
        org_codename: orgs
      }
      let data = await client.secureHttpClient.get(
        `${pathUrl}/departmentlist?lang=en`,
        {
          params,
          paramsSerializer: params => qs.stringify(params, {encode: false})
        }
      )
      commit('SET_DEPARTMENT_LIST', data.data.data)
    } catch (e) {
      Vue.$log.error(e)
    }
  },
  async setAppointmentId({commit}, id) {
    commit('SET_IS_LOADING', true)
    let data = await client.secureHttpClient.get(`${pathUrl}/appointments/${id}`)
    if (data) {
      commit('SET_APPOINTMENT_OBJECT', data.data)
    }
    commit('SET_IS_LOADING', false)
  },
  async updateAppointment({commit}, payload) {
    const {pkg, id} = payload
    commit('SET_IS_LOADING', true)
    const body = {
       is_status: pkg.is_status,
       remark: pkg.remark
    }
    try {
      await client.secureHttpClient.put(`${pathUrl}/appointments/${id}`, body)
      commit('SET_IS_LOADING', false)
      return true
    } catch (e) {
      // const errMessage = e.response.data.message || 'Incomplete information'
      Vue.$log.error(e)
      commit('SET_IS_LOADING', false)
      return false
    }
  },
}

// Mutations
const mutations = {
  SET_ORG_FILTER(state, org) {
    const selected = []

    if (org.data.length === 1) {
      org.data.forEach(d =>
        selected.push({
          codename: d.codename,
          selected: true
        })
      )
    }
    state.orgList.selected = selected
    state.orgList.all = org.data
  },
  SET_DEPARTMENT_LIST(state, departments) {
    state.departmentList = departments
  },
  RESET_LIST_STATE(state) {
    state.currentPage = defaultState().currentPage
    state.pageSize = defaultState().pageSize
    state.textSearch = defaultState().textSearch
    state.filterStatus = defaultState().filterStatus
    state.filterChannel = defaultState().filterChannel
    state.filterForPackage = defaultState().filterForPackage
    state.filterDepartment = defaultState().filterDepartment
    state.sortBy = defaultState().sortBy
    state.sortDesc = defaultState().sortDesc
    state.orgList = defaultState().orgList
  },
  RESET_STATE(state) {
    state.appointmentObject = defaultState().appointmentObject
  },
  SET_IS_LOADING(state, isLoading) {
    state.isLoading = isLoading
  },
  SET_PAGE(state, page) {
    state.currentPage = page
  },
  SET_PAGE_SIZE(state, size) {
    state.pageSize = size
  },
  SET_FILTER_DEPARTMENT(state, departments) {
    state.filterDepartment = departments
  },
  SET_FILTER_CHANNEL(state, channel) {
    state.filterChannel = channel
  },
  SET_FILTER_STATUS(state, status) {
    state.filterStatus = status
  },
  SET_FILTER_FOR_PACKAGE(state, for_package) {
    state.filterForPackage = for_package
  },
  SET_TEXT_SEARCH(state, text) {
    state.textSearch = text
  },
  SET_TOTAL_APPOINTMENTS(state, total) {
    state.totalAppointments = total
  },
  SET_APPOINTMENTS_LIST(state, appointments) {
    state.appointmentList = appointments
  },
  SET_FIELD_SORT(state, field) {
    state.sortBy = field
  },
  SET_SORT(state, sort) {
    state.sortDesc = sort
  },
  SET_APPOINTMENT_OBJECT(state, pkg) {
    state.appointmentObject = pkg.data
  },
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
